import React from 'react';
import { LineChart } from '@mui/x-charts';
import { Box, Typography } from '@mui/material';


function TrendLineChartForBu({dataset, title,bulist,xAxisLabel}) {
    const buColors = [
  '#543EA3', 
  '#3287A0', 
  '#1E9B6F', 
  '#70ABBD', 
  '#8980ac', 
  // Add more colors as needed
];

  const series = bulist.map((bu, idx) => ({
  id: String(idx),
  label: bu.charAt(0).toUpperCase()+bu.slice(1),
  dataKey: bu.toLowerCase(),
  stack: 'total',
  area: false,
  showMark: false,
  color: buColors[idx % buColors.length],
}));
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    // Format as '5 Jun'
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
  };

  return (
    <Box sx={{width: "100%", boxSizing: "border-box", padding: "24px", border: '1px solid #E5E5E5', borderRadius: '8px',backgroundColor: 'var(--white)'}}>
    <Typography variant="h6" component="h4" sx={{fontSize: '20px', fontWeight: 700, color: '#111', mb: 4}}>
        {title}
    </Typography>
    <LineChart
      dataset={dataset}
        xAxis={[
          {
            id: 'period',
            dataKey: 'period',
            scaleType: 'point',
            label:xAxisLabel,
            valueFormatter: (value, context) => {
              if (context.location === "tick") {
                return ""
              }
              return formatDate(value)
            }
          },
        ]}
        sx={{
          '& .MuiChartsAxis-root .MuiChartsAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiYAxis-root .MuiYAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiChartsAxis-root .MuiChartsAxis-tick': {stroke: 'var(--grey-CCC)' }
        }}
        yAxis={[{ width: 70, label: "Percentage",max:100,valueFormatter:(v)=>`${v}%` }]}
        series={series}
        height={300}
    />
    </Box>
  );
}

export default TrendLineChartForBu;
